import { TransfoErrorCodes } from 'types/billShock.ts'

export const HANDLED_BILL_SHOCK_TRANSFO_ERRORS = [
  TransfoErrorCodes.E304_CONTRACT_TOO_YOUNG,
  TransfoErrorCodes.E431_NO_INVOICE_FOUND,
  TransfoErrorCodes.E442_NEAR_METERREADING_MONTH,
  TransfoErrorCodes.E443_NO_FUTURE_INSTALMENTS,
  TransfoErrorCodes.E454_MISSING_SERVICE_DELIVERIES,
  TransfoErrorCodes.E547_DEFAULT_VALUES_IN_BILLSHOCK
] as const
